module.exports = __webpack_public_path__ + "img/markerarrows.cececfdb.svg";